import { FusaReply } from "@/types/replyTypes";
import { Client } from "./client";
import { ContainerOrderRequest, ContainerReply, ContainersReply, ReorderRequest, CreateContainerRequest, SaveContainerBlockRequest, UpdateContainerRequest } from "@/types/containerTypes";
import { CompleteRepeatingStepReply, CompleteRepeatingStepRequest, CreateFromFunctionRequest, GenerateReply, ReorderContainersReply } from "@/backend/express/controllers/containerController";
import { SaveBlockReply } from "@/types/operationTypes";
import { ResetStepReply } from "@/backend/express/controllers/containerController";

export class ContainerController {
  client: Client;

  constructor(client?: Client) {
    this.client = client || new Client();
  }

  public async update(req: UpdateContainerRequest): Promise<ContainerReply> {
    return this.client.update('/api/containers', req);
  }

  public async duplicate(id: string): Promise<ContainerReply> {
    return this.client.create(`/api/containers/duplicate/${id}`, {});
  }

  public async delete(id: string): Promise<FusaReply> {
    return this.client.delete(`/api/containers/${id}`);
  }

  public async saveBlock(req: SaveContainerBlockRequest): Promise<SaveBlockReply> {
    return this.client.create(`/api/containers/saveBlock/${req.container.id}`, req);
  }

  public async order(req: ContainerOrderRequest): Promise<ContainersReply> {
    return this.client.update(`/api/containers/order`, req);
  }

  public async reorder(req: ReorderRequest): Promise<ReorderContainersReply> {
    return this.client.update(`/api/containers/reorder`, req);
  }

  public async create(req: CreateContainerRequest): Promise<ContainerReply> {
    return this.client.create(`/api/containers`, req);
  }

  public async read(id: string): Promise<ContainerReply> {
    return this.client.read(`/api/containers/${id}`);
  }

  public async readBySourceId(sourceId: string): Promise<ContainersReply> {
    return this.client.read(`/api/containers/source/${sourceId}`);
  }

  public async completeRepeatingStep(id: string, req: CompleteRepeatingStepRequest): Promise<CompleteRepeatingStepReply> {
    return this.client.update(`/api/containers/completeRepeatingStep/${id}`, req);
  }

  public async generateContainers(id: string, functionalInterfaceImplementationAssignments: { [key: string]: string }): Promise<GenerateReply> {
    return this.client.create(`/api/containers/generate/${id}`, { functionalInterfaceImplementationAssignments });
  }

  public async createFromFunction(req: CreateFromFunctionRequest): Promise<FusaReply> {
    return this.client.create(`/api/containers/createFromFunction`, req);
  }

  public async resetStep(id: string): Promise<ResetStepReply> {
    return this.client.delete(`/api/containers/resetStep/${id}`);
  }
}
